const brand = document.querySelector('#brand');

const remove_h1_for_brand = () => {
    let firstChild = brand.firstElementChild;;
    if(firstChild.tagName === "H1"){
        firstChild.replaceWith(...firstChild.childNodes)
    }
}

const add_h1_for_brand = () => {
    let firstChild = brand.firstElementChild;
    if(firstChild.tagName === "DIV"){
        var wrapper = document.createElement('h1');
        firstChild.parentNode.insertBefore(wrapper, firstChild);
        wrapper.appendChild(firstChild);
    }
}





const update_brand_markup = (next_url_path) => {
    if(next_url_path === "/"){
        add_h1_for_brand();
    }else{
        remove_h1_for_brand();
    }
}


export default update_brand_markup;